module.exports = __webpack_public_path__ + "static/media/icon-refresh.64f4a81e.svg";